export default "__VITE_ASSET__vIFBt8eU__"